import axios from 'axios';
import { API_URL } from '../constants';
import {
    parseTaxonomyGroups,
    parsePages,
    parseCountryProfiles
} from './api.parsers';
import { GetMethod } from './api.types';
import { CountryProfile } from '../types';

const pathCheck = (path: string): string => (
    (trimmedPath: string) => (
        trimmedPath.startsWith('/') ? trimmedPath : `/${trimmedPath}`)
)((path.trim())
);

const apiGet: GetMethod = async (
    path, parser
) => {
    let url: string = API_URL;

    if (typeof path === 'string') {
        url += pathCheck(path);
    }
    else {
        const { path: _path, queryParams } = path;
        const queryString = new URLSearchParams(queryParams).toString();
        url += `${pathCheck(_path)}${queryString ? `?${queryString}` : ''}`;
    }

    const response = await axios.get(url);
    return parser(response.data);
};

export const getTaxonomies = () => apiGet('/taxonomies', parseTaxonomyGroups);
export const getPages = () => apiGet('/pages', parsePages);
export const getCountryResultsFromAllPages = () => {
    const results: CountryProfile[] = [];
    let currentPage = 0;
    let isLastPage = false;

    const fetchPage = () => {
        return apiGet({
            path: '/gender-data',
            queryParams: { page: currentPage.toString() }
        }, data => {
            if (!Array.isArray(data)) {
                throw new Error('Invalid country profiles response: expected an array');
            }

            isLastPage = data.length < 400;
            return parseCountryProfiles(data);
        });
    };

    return new Promise<CountryProfile[]>((resolve, reject) => {
        const fetchNextPage = () => {
            fetchPage().then(
                data => {
                    results.push(...data);

                    if (isLastPage) {
                        resolve(results);
                    }
                    else {
                        currentPage += 1;
                        fetchNextPage();
                    }
                },
                error => reject(error)
            );
        };

        fetchNextPage();
    });
};
